import { PropsWithChildren, FC } from 'react'
import { useSelector, connect } from 'react-redux'
import { Layout } from 'antd'
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons'
import { NavTitle } from '@Admin/components'
import OperationsMenu from '@OpsWb/components/OpsNav/components/OperationsMenu'

import BusinessAccountInviteModal from '~/apps/consumer/components/BusinessAccountInviteModal'
import Box from '~/core/Box'
import Image from '~/core/Image'
import Text from '~/core/Text'
import Button from '~/core/Button'
import icons from '~/apps/consumer/icons'
import { QUOTES_ORDERS } from '~/redux-modules/preferences'
import { openModal, closeModal, getModal } from '~/redux-modules/modals'

import UserAccountDropDown from './UserAccountDropDown'
import GetEarlyAccessTeamsBtn from './GetEarlyAccessTeamsBtn'
import { selectFlags } from './logic'
import styles from './styles.css'
import PremiumUpsellDrawer from './PremiumUpsellDrawer'
import TeamsEarlyAccessSurveyModal from './TeamsEarlyAccessSurveyModal'
import { ActivePunchoutSessionIndicator } from './ActivePunchoutSessionIndicator'

export const PING_DOM_CHECK = 'pingdom-check'
export const MODAL_NAME = 'UPSELL'

interface TopNavPropsType {
    adblockDetected?: boolean
    onlyShowTitle?: string
    collapsed: boolean
    showOpsNav?: boolean
    toggleCollapsed: () => void
    isOpen: boolean
    getModal: Function
    openModal: (modalName: string) => void
    closeModal: Function
}

const TopNav: FC<PropsWithChildren<TopNavPropsType>> = props => {
    const {
        adblockDetected,
        onlyShowTitle,
        collapsed,
        toggleCollapsed,
        showOpsNav,
        isOpen,
    } = props
    const { isReleasePremiumUpsellDrawerUIEnabled } = useSelector(selectFlags)

    return (
        <Layout.Header
            className={styles.layoutHeader}
            data-test-target="top-nav-layout-header"
        >
            <Box
                className={styles.wrapper}
                justifyContent="between"
                alignItems="center"
            >
                <Box display="flex" alignItems="center">
                    <Box
                        margin="0 20px"
                        alignItems="center"
                        className={PING_DOM_CHECK}
                    >
                        <Button
                            className={styles.collapseToggle}
                            type="text"
                            onClick={toggleCollapsed}
                            title={collapsed ? 'Expand menu' : 'Collapse menu'}
                        >
                            {collapsed ? (
                                <MenuUnfoldOutlined
                                    style={{
                                        fontSize: 18.75,
                                        marginBottom: '3px',
                                    }}
                                />
                            ) : (
                                <MenuFoldOutlined
                                    style={{
                                        fontSize: 18.75,
                                        marginBottom: '3px',
                                    }}
                                />
                            )}
                        </Button>
                        <Image
                            src={icons.fictivIconGreen}
                            width="52px"
                            height="18px"
                        />
                    </Box>
                    {/* This is a temp logic mess. will get cleaned up in another PR */}
                    {showOpsNav && <OperationsMenu />}
                    {!showOpsNav && onlyShowTitle && (
                        <NavTitle
                            title={onlyShowTitle}
                            marginLeft="20px"
                            marginTop="2px"
                        />
                    )}
                    {!showOpsNav && !onlyShowTitle && (
                        <Text
                            style={{
                                marginBottom: 0,
                                marginTop: 4,
                                lineHeight: '16px',
                            }}
                            element="h5"
                            fontSize="16px"
                        >
                            {QUOTES_ORDERS}
                        </Text>
                    )}
                    <ActivePunchoutSessionIndicator />
                </Box>
                {adblockDetected && (
                    <Box>
                        <p>Hey, we noticed you&#39;re using an ad blocker.</p>
                        We don&#39;t show ads here, and it interferes with our
                        ability to engage with you via our in app message
                        service. So we&#39;d appreciate it if you added our site
                        to your exceptions list.
                    </Box>
                )}
                <Box alignItems="end">
                    <BusinessAccountInviteModal showAsLink />
                    <GetEarlyAccessTeamsBtn />
                    <UserAccountDropDown openModal={props.openModal} />
                </Box>
            </Box>
            {isReleasePremiumUpsellDrawerUIEnabled ? (
                <PremiumUpsellDrawer
                    visible={isOpen}
                    onClose={() => props.closeModal(MODAL_NAME)}
                />
            ) : (
                <TeamsEarlyAccessSurveyModal
                    visible={isOpen}
                    onCancel={() => props.closeModal(MODAL_NAME)}
                />
            )}
        </Layout.Header>
    )
}

function mapStateToProps(state: {
    getModal: Function
    openModal: Function
    closeModal: Function
}) {
    const modal = getModal(state, MODAL_NAME)

    return {
        isOpen: modal.isOpen,
        closeModal,
        openModal: () => {
            openModal(MODAL_NAME)
        },
    }
}

export default connect(mapStateToProps, { openModal, closeModal, getModal })(
    TopNav,
)
